import { render, staticRenderFns } from "./AddContacts.vue?vue&type=template&id=79fe231b&scoped=true&"
import script from "./AddContacts.vue?vue&type=script&lang=js&"
export * from "./AddContacts.vue?vue&type=script&lang=js&"
import style0 from "./AddContacts.vue?vue&type=style&index=0&id=79fe231b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fe231b",
  null
  
)

export default component.exports